import React, {useEffect, useState} from "react";
import {ProductionStageFormEdit} from "../../components/production-stages/ProductionStageFormEdit";
import {useSearchParams} from "react-router-dom";
import {useGetProductionStageQuery} from "../../store/backend-api/backend.api";

export function EditProductionStageForm() {
    const [searchParams] = useSearchParams()
    const id = Number(searchParams.get("id"))
    const {data, isSuccess} = useGetProductionStageQuery(id)
    const [key, setKey] = useState(0)

    useEffect(() => {
        setKey((prevState) => prevState + 1)
    }, [data])

    return (<div key={key}>
        {isSuccess && <ProductionStageFormEdit data={data}/>}
    </div>)
}